import { useEffect } from 'react'
import { site } from '@/content/site'

const SUFFIX = `${site.name} — ${site.role}`

/**
 * Sets the browser-tab title for a route.
 *
 * The old site got this from a per-file `<title>`; a single-page app has one
 * document, so each page sets its own. Pass nothing on the landing page to use
 * the site title alone.
 */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX
  }, [title])
}
